import { Box, Tooltip, Typography } from '@mui/material';
import { CoreIconButton } from '../../../_core/components/_ui/core-button';
import { EyeIcon } from '../../../_core/components/icons';
import { SurveyQuestionStatsProps } from './question-stats.component';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const SurveyRowQuestionStats: React.FC<SurveyQuestionStatsProps> = ({ questionStat, onView }) => {
	const { text, type, isRequired, totalAnswers } = questionStat;
	const [t] = useTranslation();

	const handleViewQuestion = useCallback(() => {
		if (!questionStat) {
			return;
		}
		onView?.(questionStat);
	}, [onView, questionStat]);

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				border: '1px solid #DCDFE7',
				borderRadius: '8px',
				px: 2,
				py: 1.5,
				gap: 4,
				justifyContent: 'space-between',
				flexWrap: 'wrap',
			}}
		>
			<Typography sx={{ flex: 2, fontSize: '14px', fontWeight: 500 }}>{text}</Typography>
			<Typography sx={{ flex: 1, fontSize: '14px', fontWeight: 400 }}>{type}</Typography>
			<Typography sx={{ flex: 1, fontSize: '14px', fontWeight: 400 }}>
				{isRequired ? 'Required' : 'Optional'}
			</Typography>
			<Typography sx={{ flex: 0.5, fontSize: '14px', fontWeight: 400 }}>{totalAnswers}</Typography>
			<Tooltip title={t('buttons.tooltips.full-details')}>
				<CoreIconButton onClick={handleViewQuestion}>
					<EyeIcon sx={{ fontSize: 30 }} color="primary" />
				</CoreIconButton>
			</Tooltip>
		</Box>
	);
};
